export default __webpack_public_path__ + "846ee012f9d82d80b649fcbd6570a1a3.png";